exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.setting_options_search_customize[data-v-73682930] {\n  top: 42px !important;\n}\n.setting_options_search[data-v-73682930] {\n  height: 43px !important;\n}\n.setting_content_sub[data-v-73682930] {\n  padding-top: 85px !important;\n}\n.setting_options_wrapper[data-v-73682930]{\n  border-bottom: 1px solid #ddd;\n}\n", ""]);

// exports
